import "./Championships.scss";
import { Fragment, useEffect, useRef, useState } from "react";
import Button from "../../Components/Button/Button";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "./../../Assets/close-icon.svg";
import AttentionIcon from "./../../Assets/attention-icon.svg";
import DeleteIcon from "./../../Assets/delete-icon.svg";
import ViewIcon from "./../../Assets/details-icon.svg";
import NotificationIcon from "./../../Assets/notifiction-icon.svg";
import EditIcon from "./../../Assets/edit-icon.svg";
import AddIcon from "@mui/icons-material/AddOutlined";
import { Modal, useMediaQuery } from "@mui/material";
import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import FilterIcon from "./../../Assets/filter-icon.svg";
import { useNavigate } from "react-router-dom";
import { ChampionshipsColumns } from "../../SourceData";
import { message } from "antd";
import newRequest from "../../Utils/newRequest";
import { showErrorMessage } from "../../Utils/showErrorMessage";

const Championships = () => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const navigate = useNavigate();

  const [openMessage, setOpenMessage] = useState(false);
  const [openNotification, setOpenNotification] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rowId, setRowId] = useState("");
  const [notifictionContent, setNotifictionContent] = useState("");
  const [champions, setChampions] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [filterModel, setFilterModel] = useState({
    items: [],
    quickFilterExcludeHiddenColumns: false,
    quickFilterValues: [],
  });
  const gridToolbarRef = useRef(null);
  const [selectedRowsIds, setSelectedRowsIds] = useState([]);
  // Pagination state
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    getChampions();
  }, [paginationModel]); // Add paginationModel as dependency to fetch data when pagination changes

  const getChampions = async () => {
    setLoading(true);
    try {
      // Add pagination parameters to the request
      const res = await newRequest.get("/championships", {
        params: {
          page: paginationModel.page + 1, // API usually expects 1-based pagination
          limit: paginationModel.pageSize,
          // Add search and filter params if needed
          search: searchValue || undefined,
        },
      });

      // Check if data exists and handle accordingly
      if (res?.data?.data?.data && Array.isArray(res.data.data.data)) {
        setChampions(res.data.data.data);
        // Set total rows for pagination
        if (res.data.data.pagination) {
          setTotalRows(res.data.data.pagination.total);
        }
      } else {
        setChampions([]);
        setTotalRows(0);
      }
    } catch (error) {
      showErrorMessage(error);
      setChampions([]);
      setTotalRows(0);
    } finally {
      setLoading(false);
    }
  };

  const handleSendNotifiction = async () => {
    if (!notifictionContent.trim()) {
      message.error("يرجى ادخال محتوى الاشعار");
      return;
    }

    setOpenNotification(false);
    setLoading(true);
    try {
      await newRequest.post(`/notify_championship_subscribers`, {
        championship_id: rowId,
        content: notifictionContent,
      });
      message.success("تم ارسال الاشعار بنجاح");
    } catch (error) {
      showErrorMessage(error);
    } finally {
      setLoading(false);
      setRowId("");
      setNotifictionContent("");
    }
  };

  const handleDelete = async () => {
    setOpenMessage(false);
    setLoading(true);
    try {
      await newRequest.delete(`/championships/${rowId}`);
      await getChampions();
      message.success("تم حذف البطولة بنجاح");
    } catch (error) {
      showErrorMessage(error);
    } finally {
      setLoading(false);
      setRowId("");
    }
  };

  const handleActive = async (id) => {
    setLoading(true);
    try {
      await newRequest.put(`/championships/${id}/activateToggle`);
      await getChampions();
      message.success("تم التعديل بنجاح");
    } catch (error) {
      showErrorMessage(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (event) => {
    setSearchValue(event.target.value);
    setFilterModel((prevModel) => ({
      ...prevModel,
      quickFilterValues: [event.target.value],
    }));

    // Reset to first page when searching
    setPaginationModel({
      ...paginationModel,
      page: 0,
    });

    // Debounce search to avoid too many API calls
    const timeoutId = setTimeout(() => {
      getChampions();
    }, 500);

    return () => clearTimeout(timeoutId);
  };

  const handleFilterClickd = () => {
    if (gridToolbarRef.current) {
      gridToolbarRef.current.click();
    }
  };

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton ref={gridToolbarRef} />
      </GridToolbarContainer>
    );
  };

  const actionColumn = [
    {
      field: "action",
      headerName: "الإجراءات",
      width: 480,
      headerAlign: "center",
      align: "center",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="cell-action" style={{ display: "flex", gap: "16px" }}>
            {/* Edit Action */}
            <div
              className="cell-btn"
              onClick={() => {
                navigate(`/championships/edit/${params?.row.id}`);
              }}
            >
              <img src={EditIcon} alt="" />
            </div>
            {/* View Action */}
            <div
              className="cell-btn"
              onClick={() => {
                navigate(`/championships/view/${params?.row.id}`);
              }}
            >
              <img src={ViewIcon} alt="" />
            </div>

            {/* Delete Action */}
            <div
              className="cell-btn"
              onClick={() => {
                setOpenMessage(true);
                setRowId(params.row.id);
              }}
            >
              <img src={DeleteIcon} alt="" />
            </div>

            {/* Notification Action */}
            <div
              className="cell-btn"
              onClick={() => {
                setOpenNotification(true);
                setRowId(params.row.id);
              }}
            >
              <img src={NotificationIcon} alt="" />
            </div>

            <Button
              text={params?.row?.active === true ? "ايقاف" : "تفعيل"}
              size={"small"}
              variant={params.row.active === true ? "fill" : "outlined"}
              onClick={() => handleActive(params.row.id)}
            />

            <Button
              text="اضافة امتحان"
              size={"small"}
              variant="fill"
              onClick={() =>
                navigate("/championships/create-exam", { state: params?.row })
              }
            />
          </div>
        );
      },
    },
  ];

  return (
    <Fragment>
      <div className="championships">
        <div className="container">
          <div className="spcial-header">
            <h4 className="title">عرض البطولات</h4>
            <div className="search">
              <div className="search-container">
                <SearchIcon className="icon" />
                <input
                  type="text"
                  placeholder="ابحث عن ..."
                  onChange={handleSearch}
                  value={searchValue}
                />
              </div>

              <div className="filter-container" onClick={handleFilterClickd}>
                <img src={FilterIcon} alt="" />
              </div>
            </div>

            <Button
              size={isMobile ? "full" : "medium"}
              variant="fill"
              text="اضافة بطولة"
              icon={<AddIcon />}
              path="/championships/create"
            />
          </div>

          <div className="data-grid">
            <DataGrid
              autoHeight
              columns={ChampionshipsColumns.concat(actionColumn)}
              rows={champions.map((row, index) => {
                return {
                  ...row,
                  index:
                    paginationModel.page * paginationModel.pageSize + index + 1,
                };
              })}
              disableDensitySelector
              disableRowSelectionOnClick
              disableColumnMenu
              disableVirtualization
              slots={{
                toolbar: CustomToolbar,
              }}
              filterModel={filterModel}
              onFilterModelChange={(newModel) => setFilterModel(newModel)}
              rowCount={totalRows}
              paginationModel={paginationModel}
              onPaginationModelChange={setPaginationModel}
              pageSizeOptions={[10, 25, 50]}
              paginationMode="server"
              checkboxSelection
              onRowSelectionModelChange={(newRowSelectionModel) => {
                setSelectedRowsIds(newRowSelectionModel);
              }}
              rowSelectionModel={selectedRowsIds}
              loading={loading}
            />
          </div>
        </div>
      </div>

      {/* Delete Message Modal */}
      <Modal
        open={openMessage}
        onClose={() => {
          setOpenMessage(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="message-modal"
      >
        <div className="container">
          <div
            className="header"
            onClick={() => {
              setOpenMessage(false);
              setRowId("");
            }}
          >
            <img src={CloseIcon} alt="" />
          </div>
          <div className="body">
            <img src={AttentionIcon} alt="" />
            <h2>انتبة</h2>

            <h5>هل انت متاكد من حذف هذه البطولة من</h5>

            <h6>البطولات</h6>
          </div>
          <div className="footer">
            <button className="action-btn" onClick={handleDelete}>
              حذف
            </button>
          </div>
        </div>
      </Modal>

      {/*Notification Message Modal */}
      <Modal
        open={openNotification}
        onClose={() => {
          setOpenNotification(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="message-modal"
      >
        <div className="container">
          <div className="header">
            <div className="wrapper">
              <img src={NotificationIcon} alt="" />
              <p>اشعار كل المشتركين في البطولة</p>
            </div>
            <img
              src={CloseIcon}
              alt=""
              onClick={() => {
                setOpenNotification(false);
                setRowId("");
                setNotifictionContent("");
              }}
            />
          </div>
          <div className="body">
            <textarea
              name=""
              id=""
              placeholder="ادخل محتوي الاشعار"
              rows={5}
              value={notifictionContent}
              onChange={(e) => setNotifictionContent(e.target.value)}
            ></textarea>
          </div>
          <div className="footer">
            <button
              className="action-btn"
              onClick={handleSendNotifiction}
              disabled={!notifictionContent.trim()}
            >
              ارسال
            </button>
          </div>
        </div>
      </Modal>
    </Fragment>
  );
};

export default Championships;
